import { postRequest} from '../libs/AxiosService.util';

export async function serviceGetUserReport(params) {
    return await postRequest('reports/user', params);
}

export async function serviceDownloadUserExcel(params) {
    return await postRequest('reports/user/download', params);
}
